import { useMutation } from 'react-query'

import { activatePhysicalCardUseCase } from '@webapp/modules/spending-cards/business-logic/use-cases/ActivatePhysicalCard'

export interface IUseMutateActivatePhysicalCard {
  externalId: string
}

export const useMutateActivatePhysicalCard = () => {
  const { mutateAsync } = useMutation({
    mutationFn: async ({ externalId }: IUseMutateActivatePhysicalCard) => {
      return activatePhysicalCardUseCase({ externalId })
    },
  })

  return { activatePhysicalCard: mutateAsync }
}
